import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// import { ImagePreview } from 'vant';
import 'vant/lib/index.css';
import 'animate.css';

const app = createApp(App);

app.use(store);
app.use(router);

app.directive('feedback', {
  mounted: function (el, binding) {
    let cls = el.getAttribute('class');
    el.addEventListener(
      'touchstart',
      (e) => {
        let new_cls = cls && cls.length ? cls.concat(` ${binding.value}`) : binding.value;
        el.setAttribute('class', new_cls);
      },
      false
    );
    el.addEventListener(
      'touchend',
      (e) => {
        el.setAttribute('class', cls);
      },
      false
    );
  },
});

app.mount('#app');
